'use client'

import Link from 'next/link'
import { useLocale } from 'next-intl'
import type { ComponentProps } from 'react'
import { resolveLegacyLegalHref } from '@/lib/legal-links'

type LocaleAwareLinkProps = ComponentProps<typeof Link>

export function LocaleAwareLink({ href, ...props }: LocaleAwareLinkProps) {
  const locale = useLocale()
  const resolvedHref = typeof href === 'string' ? resolveLegacyLegalHref(href, locale) : href
  return <Link {...props} href={resolvedHref} />
}
